export const role = {
  free: "Free",
  premium: "Premium",
  admin: "Admin",
};
